import Popper from '@di-shared/features/common/Popper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';

function PowerConsumptionTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      tooltip={
        <div
          role="tooltip"
          id="tooltipBox03"
        >
          <strong className="tooltip_title">{t('T30125')}</strong>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T30126')}</li>
            <li className="tooltip_item">{t('T30127')}</li>
            <li className="tooltip_item">{t('T30128')}</li>
          </ul>
        </div>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          type="button"
          className="btn_tooltip"
          aria-describedby="tooltipBox03"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_14px"
            aria-hidden="true"
          />
        </button>
      </div>
    </Popper>
  );
}

export default PowerConsumptionTooltip;
